

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { UniqueSellingPointBlocksViewModel } from '@/types/contentServerContract';
import UniqueSellingPointItem from './UniqueSellingPointItem.vue';
import { hexToRgbValues, luma } from '@/core/color/color.service';
import tailwind from '@/styling/tailwind.config';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';

@Component({
    components: { SmartHeadline, UniqueSellingPointItem }
})
export default class UniqueSellingPointBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: UniqueSellingPointBlocksViewModel;

    @Prop({ required: true, type: Boolean })
    isFirstBlock!: boolean;

    @Prop({ type: Boolean })
    isInHalfWidth!: boolean;

    @Prop({ type: String })
    wrapperClass!: string;

    @Prop({ type: String })
    pointsClass!: string;

    private get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    private get backgroundColor() {
        return this.content.customBackgroundColor
            ? this.content.customBackgroundColor
            : this.content.backgroundColor ? '#' + this.content.backgroundColor : undefined;
    }

    private get textColor() {
        if (!this.backgroundColor) return undefined;
        const { red, green, blue } = hexToRgbValues(this.backgroundColor);
        const isDarkBackground = luma(red, green, blue) <= 0.5;
        return isDarkBackground ? tailwind.theme.colors.white : tailwind.theme.colors.black;
    }

    private get itemTextStyle(): Partial<CSSStyleDeclaration> | undefined {
        return this.textColor ? { color: this.textColor } : undefined;
    }

    private get style(): Partial<CSSStyleDeclaration> {
        return {
            backgroundColor: this.backgroundColor,
            color: this.textColor
        };
    }

    private get itemClasses(): string {
        let classes: string = '';
        if (this.isInHalfWidth) {
            if (this.content.uniqueSellingPointItems.length % 2 === 0) {
                classes = 'w-1/2';
            } else {
                classes = 'w-1/2 xl:w-1/3';
            }
        } else if (this.content.uniqueSellingPointItems.length % 5 === 0) {
            classes = 'sm:w-1/2 md:w-1/3 lg:w-1/5';
        } else if (this.content.uniqueSellingPointItems.length % 4 === 0) {
            classes = 'sm:w-1/2 md:w-1/4';
        } else {
            classes = 'sm:w-1/2 md:w-1/3';
        }
        return classes;
    }
}

